<template>
  <section class="clinicas">
    <div class="busca-container">
      <InputBusca
          v-model="searchQuery"
          placeholder="Buscar por endereço..."
      />
    </div>
    <div v-if="filteredClinics.length > 0" class="item-div">
      <CardClinicaBusca
        v-for="clinic in filteredClinics"
        :key="clinic.id"
        :clinic="clinic"
      />
    </div>

    <div v-else class="conteudo">
      <h2>CUIDAD NO ENCONTRADA</h2>
      <h3>No hemos encontrado clínicas para la ciudad que buscabas. Intente otra búsqueda.</h3>
      <button @click="goBackToSearch">Buscar otra ciudad</button>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { db } from "@/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import CardClinicaBusca from "@/components/global/cards/CardClinicaBusca.vue";
import InputBusca from "@/components/global/inputs/InputBusca.vue";

const clinics = ref([]);
const filteredClinics = ref([]);
const route = useRoute();
const router = useRouter();
const searchQuery = ref('');

const fetchClinics = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "clinics"));
    clinics.value = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    filterClinics();
  } catch (error) {
    console.error("Erro ao obter clínicas: ", error);
  }
};

const filterClinics = () => {
  const cityQuery = route.query.city || "";
  let tempClinics = clinics.value;

  if (cityQuery.trim() !== "") {
    tempClinics = tempClinics.filter((clinic) =>
        clinic.address && clinic.address.toLowerCase().includes(cityQuery.toLowerCase())
    );
  }

  if (searchQuery.value.trim() !== "") {
    tempClinics = tempClinics.filter((clinic) =>
        clinic.address && clinic.address.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }

  filteredClinics.value = tempClinics;
};

const goBackToSearch = () => {
  router.back();
};

onMounted(() => {
  fetchClinics();
});

watch(
  () => route.query.city,
  () => {
    fetchClinics();
  }
);

watch(searchQuery, () => {
  filterClinics();
});
</script>
<style scoped>
section.clinicas {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 80px 80px 80px;
  position: relative;
  background-color: #ffffff;
}

.busca-container {
  width: 100%;
  max-width: 500px;
  margin-bottom: 40px;
}

.item-div {
  width: 100%;
}

.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
}

.conteudo  h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-1);
}
.conteudo  h2 {
  font-family: var(--estilo);
  font-size: var(--f5);
  color: var(--cor-escuro-1);
  text-align: center;
  margin: 20px 0 10px 0;
}
.conteudo  span {
  color: #2280b4;
}
.conteudo button {
  margin-top: 20px;
  font-family: var(--bold);
  padding: 15px 25px;
  border-radius: 50px;
  background-color: #2280b4;
  color: white;
  border: none;
  cursor: pointer;
}

.conteudo button:hover {
  background-color: #103e7f;
}
@media screen and (max-width: 1000px) {
  section.clinicas {
    padding: 50px 20px 60px 20px;
  }
}
</style>
